import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

@Component({
    selector: 'app-round-percentage',
    templateUrl: './round-percentage.component.html',
    styleUrls: ['./round-percentage.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoundPercentageComponent implements OnInit {
  @Input() percentage?: number;
  @Input() value?: number;
  @Input() label: string;
  @Input() unity: string = 'g';

  constructor() {}

  ngOnInit(): void {}
}
